<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="昵称" prop="nick">
                <el-input v-model="dataForm.nick" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="头像">
                <el-upload :class="{hide:hideUpload}" action="http://www.xzunet.cn:8080/u-net-mall-admin/file/upload/one"
                           :headers="headers" list-type="picture-card" :file-list="mainFileList"
                           :before-upload="beforeAvatarUpload"
                           :on-success="handleAvatarSuccess" :on-preview="handlePictureCardPreview"
                           :on-remove="handleRemove" :limit="1">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
            </el-form-item>
<!--            <el-form-item label="性别(0未知 1男 2女)" prop="gender">-->
<!--                <el-select v-model="dataForm.gender" placeholder="性别(0未知 1男 2女)">-->
<!--                    <el-option v-for="item in genders"-->
<!--                               :key="item.value"-->
<!--                               :label="item.label"-->
<!--                               :value="item.value">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="会员等级" prop="level">
                <el-select v-model="dataForm.level"
                           placeholder="会员等级">
                    <el-option v-for="item in levels"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="上级邀请码" prop="parentInvitationCode">
                <el-input v-model="dataForm.parentInvitationCode" placeholder="邀请码"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="identityCardNumber">
                <el-input v-model="dataForm.identityCardNumber" placeholder="身份证号"></el-input>
            </el-form-item>
            <el-form-item label="身份证地址" prop="identityCardNumber">
                <el-input v-model="dataForm.identityCardAddress" placeholder="身份证地址"></el-input>
            </el-form-item>
            <el-form-item label="购买节点个数" prop="purchaseNumber">
                <el-input v-model="dataForm.purchaseNumber" placeholder="购买节点个数"></el-input>
            </el-form-item>
            <el-form-item label="代理区域编码" prop="agentAreaCode">
                <el-input v-model="dataForm.agentAreaCode" placeholder="代理区域编码"></el-input>
            </el-form-item>
            <!--            <el-form-item label="启用状态(1启用 2禁用)" prop="enableStatus">-->
            <!--                <el-input v-model="dataForm.enableStatus" placeholder="启用状态(1启用 2禁用)"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="合伙人申请状态" prop="verifyStatus">
                <el-select v-model="dataForm.partnerApplyStatus" placeholder="审核状态">
                    <el-option v-for="item in ApplyStatus"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="法人申请状态" prop="verifyStatus">
                <el-select v-model="dataForm.juridicalApplyStatus" placeholder="审核状态(1待审核 2已通过 3已拒绝)">
                    <el-option v-for="item in juridicalApplyStatus"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        data() {
            return {
                visible: false,
                juridicalApplyStatus: [{
                    value: 0,
                    label: '未申请'
                }, {
                    value: 1,
                    label: '审核中'
                }, {
                    value: 2,
                    label: '已通过'
                }, {
                    value: 3,
                    label: '已拒绝'
                }],
                ApplyStatus: [{
                    value: 0,
                    label: '未申请'
                }, {
                    value: 1,
                    label: '审核中'
                }, {
                    value: 2,
                    label: '已通过'
                }, {
                    value: 3,
                    label: '已拒绝'
                }],
                genders: [{
                    value: 1,
                    label: '男'
                }, {
                    value: 2,
                    label: '女'
                }],
                levels: [{
                    value: 0,
                    label: '优客'
                }, {
                    value: 1,
                    label: '节点'
                }, {
                    value: 2,
                    label: '法人'
                }, {
                    value: 3,
                    label: '合伙人'
                }],
                dataForm: {
                    id: '',
                    nick: '',
                    avatar: '',
                    // identityCardPictures: [],
                    mobile: '',
                    password: '',
                    gender: '',
                    level: '',
                    parentInvitationCode: '',
                    identityCardNumber: '',
                    identityCardAddress: '',
                    purchaseNumber: '',
                    agentAreaCode: '',
                    partnerApplyStatus: '',
                    juridicalApplyStatus: '',
                    // lastLoginTime: '',
                    // creator: '',
                    // deptId: '',
                    // createDate: '',
                    // updateDate: ''
                },
                //图片上传
                headers: {
                    token: this.cookie.get('token')
                },
                dialogImageUrl: '',
                dialogVisible: false,
                hideUpload: false,
                imgsHideUpload: false,
                // mainFileList: [{
                //   name: 'main.jpeg',
                //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                // }]
                mainFileList: [],
                imgsFileList: [],
                uploadUrl: ''
            }
        },
        computed: {
            dataRule() {
                return {
                    nick: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    avatar: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    mobile: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    gender: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    level: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    parentInvitationCode: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    this.mainFileList = []
                    this.imgsFileList = []
                    this.hideUpload = false
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`pms/umsmember/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                    //初始化图
                    this.mainFileList = []
                    this.mainFileList = [{
                        name: 'main.jpeg',
                        url: this.dataForm.avatar
                    }]
                    this.imgsFileList = []
                    this.dataForm.identityCardPictures.forEach((item, index) => {
                        this.imgsFileList.push({
                            name: '',
                            url: item
                        })
                    })
                    //判断图片是否超过限制
                    this.hideUpload = true
                    this.imgsHideUpload = this.dataForm.identityCardPictures.length >= 5
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('pms/umsmember/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false}),
            //文件上传
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isLt2M) {
                    this.$message.error('图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            handleAvatarSuccess(res, file, fileList) {
                // this.dataForm.mainPicture = URL.createObjectURL(file.raw);
                this.dataForm.avatar = res.data
                this.hideUpload = fileList.length >= 1
            },
            handleRemove(file, fileList) {
                this.dataForm.avatar = ''
                this.hideUpload = fileList.length >= 1;
            },

            ImgshandleAvatarSuccess(res, file, fileList) {
                this.dataForm.identityCardPictures.push(res.data)
                this.imgsHideUpload = fileList.length >= 5;
            },
            ImgshandleRemove(file, fileList) {
                //删除数组中的某个元素
                this.dataForm.identityCardPicture.forEach((item, index) => {
                    if (item == file.response.data) {
                        this.dataForm.identityCardPicture.splice(index, 1)
                    }
                })
                this.imgsHideUpload = fileList.length >= 5;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },

            addAttribute() {
                this.dataForm.attribute.push({
                    name: this.attributeName,
                    value: []
                })
                this.attributeName = ''
            },
            addAttributeValue(index) {
                var attributeValue = this.$refs[`value${index}`][0].value
                this.dataForm.attribute[index].value.push(attributeValue)
            },
            deleteAttribute(index) {
                this.dataForm.attribute.splice(index, 1)
            },
            deleteAttributeValue(index, valueIndex) {
                this.dataForm.attribute[index].value.splice(valueIndex)
            },
            // 上传图片之前
            uploadBeforeUploadHandle(file) {
                if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !==
                    'image/gif') {
                    this.$message.error('只支持jpg、png、gif格式的图片！')
                    return false
                }
            },
            // 上传图片成功
            uploadSuccessHandle(res, file, fileList) {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.quillEditor.insertEmbed(this.quillEditor.getSelection().index, 'image', res.data.src)
            }
        }
    }
</script>
